@if (loading()) {
  <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
} @else if (!prepaid()) {
  <div class="m-auto mt-40 text-center">No prepaid found</div>
} @else {
  @let vendorValue = vendorId()!;

  <div class="bg-aux-gray-light px-7 py-4">
    <div
      class="mb-6 flex max-w-max cursor-pointer items-center text-aux-blue-light-200"
      [routerLink]="[prepaidsLink]"
    >
      <aux-icon name="ArrowLeft" class="mr-2" />
      <div>Back to Prepaids</div>
    </div>

    <div class="mb-4 text-xl font-bold">
      {{ vendorName() }}
    </div>

    <div class="flex">
      <div class="mr-2 text-aux-gray-dark-100">Total Prepaid Balance</div>
      <div class="mr-5">
        {{ prepaidTotalBalance() }}
      </div>

      <div class="mr-2 text-aux-gray-dark-100">Short Term</div>
      <div class="mr-5">
        {{ prepaidShortTermBalance() }}
      </div>

      <div class="mr-2 text-aux-gray-dark-100">Long Term</div>
      <div>
        {{ prepaidLongTermBalance() }}
      </div>
    </div>
  </div>

  <div class="px-7 py-6">
    <aux-notes
      [title]="'Terms'"
      [notesControl]="notesControl"
      placeholder="Prepaid Terms..."
      [hasEditPermission]="!isNotesDisabled()"
      [disabledTooltipText]="notesTooltipText()"
      (saveNotes)="saveNotes()"
      (cancelNotes)="cancelNotes()"
    />

    <aux-adjustments-to-prepaid
      [isEditDisabled]="isNotesDisabled()"
      class="mt-6 block"
      [vendorId]="vendorValue"
      [vendorCurrency]="vendorCurrency()"
      [vendorName]="vendorName()"
      (adjustmentsSaved)="onAdjustmentsSaved()"
    />
  </div>
}
